import styled from "styled-components";
import heroImg from "../../assets/images/hero.jpg";

export const HeroContainer = styled.header`
  width: 100%;
  height: 652px;
  background: url(${heroImg}) no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 4.8rem;
  position: relative;
  @media (max-width: 600px) {
    width: 100%;
    background: url(${heroImg}) no-repeat;
    background-size: contain;
    height: 300px;
    margin-top: 4rem;
  }

  @media (max-width: 480px) {
    background: none;
  }
  @media (max-width: 360px) {
    overflow: hidden;
  }
`;
